import React, { useEffect, useState } from "react";
import { Grid2 } from "@mui/material";
import { useSetState } from "Utils/Helpers/Hooks";
import Inputer from "Utils/Helpers/Inputer";
import MButton from "Utils/Helpers/MButton";
import { useDispatch } from "react-redux";
import { HandleLoading } from "Utils/Helpers/ApiServices";
import { enqueueSnackbar } from "notistack";
import CheckApiStatus from "Utils/Constants/CheckApiStatus";
import { setCharacterData } from "../../../../../Redux/slices/mngrSlice";
import MFieldImage from "Utils/Helpers/MFieldImage";
import { post_characters } from "http/components/Characters";

export default function AddCharactersData() {
  const dispatch = useDispatch();
  const [image, setImage] = useState(null);
  const [controls, setControls] = useSetState({
    code: {
      label: "Code",
      type: "text",
      multiLine: false,
      placeholder: "Code",
      value: "",
      validation: false,
      size: { md: 4, sm: 6, xs: 12 },
    },
    name: {
      label: "Name",
      type: "text",
      multiLine: false,
      placeholder: "Name",
      value: "",
      validation: false,
      size: { md: 4, sm: 6, xs: 12 },
    },
    price: {
      label: "Price (ETH)",
      type: "number",
      multiLine: false,
      placeholder: "Price (ETH)",
      value: "",
      validation: false,
      size: { md: 4, sm: 6, xs: 12 },
    },
    rarible: {
      label: "Rarible",
      type: "text",
      multiLine: false,
      placeholder: "Rarible",
      value: "",
      validation: false,
      size: { md: 6, sm: 6, xs: 12 },
    },
    description: {
      label: "Description",
      type: "text",
      multiLine: true,
      placeholder: "Description",
      value: "",
      validation: false,
      size: { md: 6, sm: 12, xs: 12 },
    },
  });

  useEffect(() => {
    onClear();
  }, []);

  const onClear = () => {
    setControls({ code: { value: "", validation: false } });
    setControls({ name: { value: "", validation: false } });
    setControls({ price: { value: "", validation: false } });
    setControls({ rarible: { value: "", validation: true } });
    setControls({ description: { value: "", validation: false } });
    setImage(null);
  };

  const setValue = (name, value, validation) => {
    let _validation = validation;
    if (name === "rarible" && !value.includes("https://rarible.com"))
      _validation = false;
    if (name === "rarible" && value === "")
      _validation = true;
    setControls({ [name]: { value, validation: _validation } });
  };

  const onSelectImage = (selected) => {
    setImage(selected);
  };

  const onSubmit = async () => {
    const { code, name, price, rarible, description } = controls;
    if (!rarible.validation) {
      enqueueSnackbar("Invalid Rarible URL", { variant: "error" });
    } else if (code.validation && price.validation && image) {
      dispatch(HandleLoading(true));
      let formData = new FormData();
      formData.append("code", code.value);
      formData.append("price", price.value);
      formData.append("burl", rarible.value);
      formData.append("name", name.validation ? name.value : "");
      formData.append(
        "description",
        description.validation ? description.value : ""
      );
      formData.append("image", image);
      const response = await post_characters(formData);
      if (CheckApiStatus(response)) {
        onClear();
        dispatch(setCharacterData(true));
        enqueueSnackbar("Insert Success", { variant: "success" });
      }
      dispatch(HandleLoading(false));
    } else {
      enqueueSnackbar("Enter data correctly", { variant: "error" });
    }
  };

  return (
    <Grid2 container spacing={2}>
      <Grid2 size={{ xs: 12 }}>
        <MFieldImage
          name={"Character image"}
          image={image}
          onChange={onSelectImage}
        />
      </Grid2>
      {Object.keys(controls).map((key, index) => {
        return (
          <Grid2 size={controls[key].size} key={key + index}>
            {["text", "number"].includes(controls[key].type) && (
              <Inputer
                id={key}
                setValue={setValue.bind(this)}
                value={controls[key].value}
                label={controls[key].label}
                placeholder={controls[key].placeholder}
                type={controls[key].type}
                multiLine={controls[key].multiLine}
              />
            )}
          </Grid2>
        );
      })}
      <Grid2 size={{ xs: 12 }}>
        <MButton label={"Save"} onClick={onSubmit} />
      </Grid2>
    </Grid2>
  );
}
